import * as React from 'react';
import { useEffect, useState } from 'react';
import { useIntersect } from '../../../../Utilities/UseIntersect';

import { includes } from 'lodash';


import SiteMenu from '../SiteMenu';
import Icon from '../../../../Components/Icon';

export interface IMainMenuProps {
    /* DOM to parse */
    dom: string | object[];
    /** Unsafe config */
    config?: any;
    /** Overlay closing event */
    closeOverlay: (e) => void;
    /** Overlay opening event */
    openOverlay: (e) => void;
    /** Opened overlays */
    openOverlays: string[];
    componentMapper: (maybeComponent: string, maybeContent: string, maybeConfig) => React.Component;
}

const MainMenu: React.FunctionComponent<IMainMenuProps> = (props) => {
    const { openOverlays, openOverlay, closeOverlay } = props;

    const [isMenuHiddenRight, setIsMenuHiddenRight] = useState(false);
    const [isMenuHiddenLeft, setIsMenuHiddenLeft] = useState(false);

    const pre = useIntersect({
        root: null,
        rootMargin: '0px',
        threshold: Array.from(Array(100).keys(), (i) => i / 100),
    });
    const post = useIntersect({
        root: null,
        rootMargin: '0px',
        threshold: Array.from(Array(100).keys(), (i) => i / 100),
    });



    // Watch side intersections

    useEffect(() => {
        if (pre.entry) {
            if (pre.entry.intersectionRatio > 0) {
                setIsMenuHiddenLeft(false);
            } else {
                setIsMenuHiddenLeft(true);
            }
        }
    }, [pre.entry]);

    useEffect(() => {
        if (post.entry) {
            if (post.entry.intersectionRatio > 0) {
                setIsMenuHiddenRight(false);
            } else {
                setIsMenuHiddenRight(true);
            }
        }
    }, [post.entry]);

    const handleScroll = (amount) => {
        document.getElementsByClassName('site-menu__wrapper')[0].scrollBy(amount, 0);
    };

    // Main output
    return (
        <React.Fragment>
            {isMenuHiddenLeft && (
                <button className="site-menu__scroll left" onClick={() => handleScroll(-100)} aria-label={props.config?.labelLeft}><Icon kind="arrow5-left" width={16} height={16}/></button>
            )}
            <div className="site-menu__wrapper">
                <div style={{ height: 0, width: 0 }} ref={pre.node}/>
                <SiteMenu
                    dom={props.dom}
                    mobileMenuOpen={includes(openOverlays, 'mobilemenu')}
                    openMobileMenu={(e) => {
                        e.preventDefault();
                        closeOverlay({ name: 'all', });
                        openOverlay({ name: 'mobilemenu', });
                    }}
                    closeMobileMenu={(e) => {
                        e.preventDefault();
                        closeOverlay({ name: 'all', });
                    }}
                    mobileMode={props.config?.mobileMode ? props.config?.mobileMode : 'overlay'}
                    mobileTarget={props.config?.mobileTarget}
                    target={props.config?.target || undefined}
                    labelBack={props.config?.labelBack}
                    labelViewAll={props.config?.labelViewAll}
                    iconDrop={props.config?.iconDrop}
                    componentMapper={props.componentMapper}
                    interactionMode={props.config?.mode ? props.config.mode : 'click'}
                />
                <div style={{ height: 0, width: 0, position: 'relative', left: '-1px' }} ref={post.node}/>
            </div>
            {isMenuHiddenRight && (
                <button className="site-menu__scroll right" onClick={() => handleScroll(100)} aria-label={props.config?.labelRight}><Icon kind={'arrow5-right'} width={16} height={16}/></button>
            )}

        </React.Fragment>
    );
};

MainMenu.displayName = 'MainMenu';

export default MainMenu;
